import React from 'react'
import Layout from 'features/layout/components/Layout'
import People from '../components/People'

const PeoplePage = (props) => {
  return (
    <Layout>
      <People />
    </Layout>
  )
}

export default PeoplePage
